const WORDS = [
  "ERP",
  "e-Fatura",
  "POS",
  "Barkod",
  "Bulut",
  "Wolvox",
  "Restoran Otomasyonu",
  "Ön Muhasebe",
  "e-Arşiv",
  "Teknik Servis",
];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <section className="overflow-hidden border-y border-ink/5 bg-cloud py-10" data-testid="marquee">
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {row.map((w, i) => (
          <div key={i} className="flex items-center gap-10">
            <span className="text-3xl font-extrabold tracking-tight text-ink/15 md:text-5xl">
              {w}
            </span>
            <span className="h-2 w-2 rounded-full bg-orange" />
          </div>
        ))}
      </div>
    </section>
  );
}
